// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__BUXam","signatureBlock":"Footer_signatureBlock__AFSdO","signature":"Footer_signature__1eFF8"};